var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('pageLoadProgress'), _c('div', {
    staticClass: "min-h-screen"
  }, [_vm.isRouterAlive ? _c('router-view') : _vm._e()], 1), _c('Tabbar'), _c('weixinAuthorizeUserInfoMask')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };